import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Empty, MailIcon, Pagination, Paragraph, Table } from '@treams/treams-ui';

export default function SentEmails(props: { id: string }) {
	const { t } = useTranslation();

	const [pagination, setPagination] = useState<Pagination>({ last: 10 });

	const user = graphql.useUserQuery({
		variables: { id: props.id },
		fetchPolicy: 'network-only',
	});
	const query = graphql.useSentEmailsQuery({
		variables: { email: user.data?.user.email, ...pagination },
		skip: !user.data,
		fetchPolicy: 'network-only',
	});

	const emails = query.data?.sentEmails.edges ?? [];
	const pageInfo = query.data?.sentEmails.pageInfo as graphql.PageInfo | undefined;
	const showPaging = Boolean(pageInfo?.hasNextPage || pageInfo?.hasPreviousPage);

	return (
		<Box mb={5}>
			<Paragraph mb={3}>{t('settings.employees.sentEmails.description')}</Paragraph>
			<Table>
				<Table.Header>
					<Table.Cell basis={0.3}>{t('settings.employees.sentEmails.columns.sentAt')}</Table.Cell>
					<Table.Cell basis={0.3}>{t('settings.employees.sentEmails.columns.email')}</Table.Cell>
					<Table.Cell basis={0.4}>{t('settings.employees.sentEmails.columns.subject')}</Table.Cell>
				</Table.Header>
				{query.data &&
					emails.map(({ node }) => (
						<Table.Row key={node.id}>
							<Table.Cell basis={0.3}>{moment(node.sentAt).format('LLL')}</Table.Cell>
							<Table.Cell basis={0.3}>{node.recipientEmail}</Table.Cell>
							<Table.Cell basis={0.4}>{node.subject}</Table.Cell>
						</Table.Row>
					))}
			</Table>
			{query.data && emails.length === 0 && (
				<Flex mt={3} justifyContent="center">
					<Empty
						small
						icon={<MailIcon />}
						title={t('settings.employees.sentEmails.empty.title')}
						description={t('settings.employees.sentEmails.empty.description')}
					/>
				</Flex>
			)}
			{showPaging && (
				<Table.Paging pageInfo={pageInfo as graphql.PageInfo} onPaginate={setPagination} />
			)}
		</Box>
	);
}
